<div class="payment-partial-container">
  <div class="paymentPartialWrapper">
    <div class="paymentPartialWrapperInfoCounterAgents">
      <h1>Предварительный просмотр заявки</h1>
      <div class="infoCounterAgentsItem">
        <div>Адрес сдачи груза: {{typeof dataForm.sender.addressCargoPickup === 'object' ? dataForm.sender.addressCargoPickup.address : dataForm.sender.addressCargoPickup}}</div>
        <div>Наименование отправителя: {{dataForm.sender.senderType ? `${dataForm.sender.innSender} ${dataForm.sender.name}` : `${dataForm.sender.fioSender}` }}</div>
        <div>Телефон отправителя: {{dataForm.sender.phoneSender}}</div>
        <div>Эл. почта: {{dataForm.sender.emailSender || '-'}}</div>
      </div>
      <div class="infoCounterAgentsItem">
        <div>Адрес выдачи груза: {{typeof dataForm.consignee.addressCargoDelivery === 'object' ? dataForm.consignee.addressCargoDelivery.address : dataForm.consignee.addressCargoDelivery}}</div>
        <div>Наименование получателя: {{dataForm.consignee.consigneeType ? `${dataForm.consignee.innConsignee} ${dataForm.consignee.name}` : `${dataForm.consignee.fioConsignee}` }}</div>
        <div>Телефон получателя: {{dataForm.consignee.phoneConsignee}}</div>
        <div>Эл. почта: {{dataForm.consignee.emailConsignee || '-'}}</div>
      </div>
    </div>
    <div :class="{calcInfoWrapper: true, loading: dataFormCalculator.loading}">
      <h4 style="margin-block: 10px">Общие данные по грузу</h4>
      <div class="tableItemCalc">
        <div>Общий объём</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.totalVolume || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Общий вес</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.totalWeight || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>

      <h4 style="margin-block: 10px">Стоимость перевозки</h4>
      <div class="tableItemCalc">
        <div>МежТерминальная Перевозка</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.transportation || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Адресный забор груза</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.cargoPickUp || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Оплата за дальность забора</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.extraChargeForCargoPickUp || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Доставка "до двери"</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.cargoDelivery || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Оплата за дальность доставки</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.extraChargeForCargoDelivery || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>

      <h5 style="margin-block: 10px">Дополнительные услуги:</h5>
      <div class="tableItemCalc">
        <div>Дополнительная упаковка</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.package || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Тёплое место</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.warmPlace || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Комиссия на наложенный платеж</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.cashOnDeliveryAmount || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Комиссия за выкуп груза</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.costForTheRedemptionOfCargo || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Удорожание от объявленной стоимости</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.costWarranty || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <div>Возврат документов</div>
        <div v-if="!dataFormCalculator.loading">{{ dataFormCalculator.calculatedData.shippingCost.costForReturningDocuments || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
      <div class="tableItemCalc">
        <h4 style="margin-block: 10px; font-size: 16px">Итоговая сумма:</h4>
        <div v-if="!dataFormCalculator.loading" style="font-weight: bold">{{ dataFormCalculator.calculatedData.shippingCost.total || "0" }}</div>
        <div v-else>Загрузка</div>
      </div>
    </div>
  </div>
  <el-form-item class="acceptance" prop="payment.isAgreeDataProcessing">
    <el-checkbox class="white-space--normal" label="Я даю согласие на обработку моих персональных данных" v-model="dataForm.payment.isAgree"
  /></el-form-item>
  <div class="bord_button">
    <el-form-item>
      <el-button class="button__send" type="primary" @click="$emit('click-button-back')"> Назад </el-button>
    </el-form-item>
    <el-form-item>
      <el-button class="button__send white-space--normal" type="primary" @click="$emit('submit-form-sender', ruleFormRef)" :disabled="!dataForm.payment.isAgree || newSubmissionInfo.loading">
        {{newSubmissionInfo.loading ? 'Отправляем заявку' : 'Отправить заявку'}}
      </el-button>
    </el-form-item>
  </div>
</div>
